import * as ko from "knockout";
import { App } from "../app";
import { Api } from "../app-api";

const divModel: HTMLDivElement = document.querySelector("#divContactUsModel");
const divRoot: HTMLDivElement = document.querySelector("#ko-contact-us");
const inputSubject: HTMLInputElement = document.querySelector("#subject");

export class ViewModel {
    busy = ko.observable(false);

    name = ko.observable<string>();
    email = ko.observable<string>();
    order = ko.observable<string>();
    subject = ko.observable<string>();
    message = ko.observable<string>();
    region = ko.observable<string>();
    cancelType = ko.observable<string>();
    searchedKb = ko.observable(false);

    showRegions: ko.PureComputed<boolean>;
    showCancelType: ko.PureComputed<boolean>;

    initForm: () => void;
    submit: () => void;

    constructor(model: any) {
        let self = this;

        const data = JSON.parse(model);

        self.showRegions = ko.pureComputed(() => {
            return self.subject() === "General Inquiries";
        }, self);

        self.showCancelType = ko.pureComputed(() => {
            return self.subject() === "I want to cancel my registration";
        }, self);

        self.showRegions.subscribe(newVal => {
            if (!newVal) { self.region(""); }
        });

        self.showCancelType.subscribe(newVal => {
            if (!newVal) { self.cancelType(""); }
        });

        self.busy.subscribe(newVal => App.busy(newVal));

        //self.subject.subscribe(newVal => console.log('subject: ' + newVal));

        self.initForm = () => {
            self.subject(inputSubject.value);
            self.order("");
            self.message("");
            self.region("");
            self.cancelType("");
            self.searchedKb(false);
        }

        self.submit = () => {
            if (!self.busy() && self.validate())
                self.send();
        }

        //console.log('contact-us: initialized');
        //console.log('testing: ' + data.testing);
    }

    private closeForm() {
        //console.log('contact-us: closeForm');
        // hide form
        document.querySelectorAll('[data-contact-reveal]')
            .forEach(x => {
                x.classList.remove('showing');
                x.classList.add('hiding')
            });

        // jump to top of page
        App.scrollTop(300);

        // reset the inner text to default
        //(document.querySelector('.button-option') as HTMLDivElement).innerText = 'Choose an option';
        (document.getElementById("contact-us-dropdown-select") as HTMLSelectElement).selectedIndex = 0;
    }

    private toJson() {
        let self = this;

        return {
            name: self.name(),
            email: self.email(),
            order: self.order(),
            subject: self.subject(),
            message: self.message(),
            //region: self.showRegions() ? self.region() : "",
            region: self.region(),
            //cancelType: self.showCancelType() ? self.cancelType() : "",
            cancelType: self.cancelType(),
            searchedKb: self.searchedKb()
        };
    }

    private send() {
        let self = this;

        self.busy(true);

        const data = self.toJson();

        Api.ContactUs(data)
            .done(results => {
                if (results.error) { return App.alertError(results.message); }
                self.closeForm();
                App.alertSuccess(results.message);
            })
            .always(() => self.busy(false));
    }

    private validate() {
        let self = this;

        if (self.showRegions() && self.region() == "") {
            App.alertWarning("Select a region you're inquiring about.");
            return false;
        }

        if (self.showCancelType() && self.cancelType() == "") {
            App.alertWarning("Are you requesting a credit or refund?");
            return false;
        }

        return true;
    }
}

function init() {
    if (divModel) {
        ko.applyBindings(new ViewModel(divModel.textContent), divRoot);
    }
}

$(document).ready(() => init());